import { DEFAULT_CHAIN_ID } from "../constants";
import { tokenList } from "@/constants/tokens";

export const useTokenList = () => {
  return tokenList.filter((token) => token.chainId === DEFAULT_CHAIN_ID);
};
